import { APP_URL, MARKETING_URL, STATUS_URL } from '@/lib/config'
import { Link } from 'react-router-dom'

/**
 * The header's site links for narrow screens, where the link row and Log in
 * are hidden: without them a phone could reach Log in only from the footer.
 */
export function SiteLinks({ onNavigate }: { onNavigate?: () => void }) {
  return (
    <div className="site-links">
      <Link to="/" aria-current="page" onClick={onNavigate}>
        Help center
      </Link>
      <a href={`${MARKETING_URL}/features`}>Product</a>
      <a href={`${MARKETING_URL}/pricing`}>Pricing</a>
      <a href={STATUS_URL}>Status</a>
      <a href={`${APP_URL}/login`}>Log in</a>
    </div>
  )
}
